import { Trans, useLingui } from '@lingui/react/macro';

import { FilterCheckboxItem } from '@/design_system/Filters/FiltersMenu/FilterCheckboxItem';
import { FiltersMenu, FiltersSubMenu } from '@/design_system/Filters/FiltersMenu/FiltersMenu';
import { FilterTag } from '@/design_system/Filters/FiltersMenu/FilterTag';
import IconWorld from '@/icons/World.svg';
import { AGREEMENT_TYPE_LABELS } from '@/models/agreements';

import { useFilters } from '../FiltersState';

export const FiltersAgreementType = ({ tag }: { tag?: boolean }) => {
  const { t, i18n } = useLingui();

  const {
    agreementTypes: { agreementTypes, setAgreementTypes },
  } = useFilters();

  const options = AGREEMENT_TYPE_LABELS.map(({ id, label }) => (
    <FilterCheckboxItem
      key={id}
      checked={agreementTypes.includes(id)}
      onChange={(checked) => {
        if (checked) {
          setAgreementTypes([...agreementTypes, id]);
        } else {
          setAgreementTypes(agreementTypes.filter((type) => type !== id));
        }
      }}
    >
      {i18n._(label)}
    </FilterCheckboxItem>
  ));

  if (tag) {
    if (agreementTypes.length === 0) {
      return null;
    }

    const numberOfTypes = agreementTypes.length;

    return (
      <FiltersMenu
        button={
          <FilterTag
            label={t({
              id: 'settings.organization.entities.agreements.filters.type.label',
              message: 'Type',
            })}
            value={
              agreementTypes.length === 1 ? (
                i18n._(AGREEMENT_TYPE_LABELS.find((type) => type.id === agreementTypes[0])!.label)
              ) : (
                <Trans id="settings.organization.entities.agreements.filters.type.multiple">
                  {numberOfTypes} types
                </Trans>
              )
            }
            tooltip={
              agreementTypes.length > 1
                ? agreementTypes
                    .map((type) =>
                      i18n._(AGREEMENT_TYPE_LABELS.find((st) => st.id === type)!.label)
                    )
                    .join(', ')
                : undefined
            }
            onClear={() => setAgreementTypes([])}
          />
        }
      >
        {options}
      </FiltersMenu>
    );
  }

  return (
    <FiltersSubMenu
      icon={<IconWorld />}
      label={t({
        id: 'settings.organization.entities.agreements.filters.type.label',
        message: 'Type',
      })}
    >
      {options}
    </FiltersSubMenu>
  );
};
